import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from "../authContext";
import Navigation from "./navigation";
import Footer from "./components/footer/footer";
import { Backdrop, Box, Button, Chip, Container, Fade, Grid, Modal, Snackbar, SnackbarContent, Typography } from "@mui/material";
import CustomerService from "../services/customer/customerService";
import { fontSizeHeader, fontSizeText, fontSizeTextSmall, grayHex, textStyle } from "../helper/style";
import { format } from "date-fns";
import { NumericFormat } from "react-number-format";

import logoMandiri from "../assets/mandiri.png";
import logoBri from "../assets/bri.svg";
import logoBni from "../assets/bni.svg";
import logoCimb from "../assets/cimb.svg";
import logoPermata from "../assets/permata.svg";
import logoSampoerna from "../assets/sampoerna.svg";
import logoBjb from "../assets/bjb.svg";
import logoBsi from "../assets/bsi.svg";
import logoQris from "../assets/qris.svg";
import logoJnt from "../assets/logoJnt.png";
import logoOvo from "../assets/logoOvo.png";
import logoDana from "../assets/logoDana.png";
import noImage from "../../src/assets/no-image.png";
import ChatIcon from '@mui/icons-material/Chat';
import SmartphoneIcon from '@mui/icons-material/Smartphone';

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  maxWidth: "70%",
  maxHeight: "80vh",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "12px",
  overflowY: "auto",
  overflowX: "hidden"
};

const OrderDetailPage = () => {
  const { id } = useParams();
  const { auth } = useAuth();
  const imageUrl = process.env.REACT_APP_IMAGE_URL
  const navigate = useNavigate();

  const [ShowSuccess, setShowSuccess] = useState(false);
  const [MsgSuccess, setMsgSuccess] = useState("");
  const [showError, setShowError] = useState(false);
  const [msgError, setMsgError] = useState("");
  const [orderData, setOrderData] = useState([]);
  const [paymentData, setPaymentData] = useState(null);
  const [deliveryData, setDeliveryData] = useState(null);
  const [addressData, setAddressData] = useState(null);
  const [date, setDate] = useState(null);
  const [status, setStatus] = useState(null);
  const [totalPrice, setTotalPrice] = useState(0);
  const [trackData, setTrackData] = useState(null);

  const [trackDialog, setTrackDialog] = useState(false);

  const getStatusColor = (key) => {
    let bg = ''
    let text = ''
  
    if (key === 'DRAFT') {
      bg = '#A0A0A0'
      text = 'black'
    } else if (key === 'WAITING_FOR_PAYMENT') {
      bg = '#FE8A01'
      text = 'white'
    } else if (key === 'PAID') {
      bg = '#5DB7DE'
      text = 'black'
    } else if (key === 'PACKAGED') {
      bg = '#0074CC'
      text = 'white'
    } else if (key === 'ON_DELIVERY') {
      bg = '#9B30FF'
      text = 'white'
    } else if (key === 'DELIVERED') {
      bg = '#19B600'
      text = 'white'
    } else if (key === 'CANCELED') {
      bg = '#E50B0B'
      text = 'white'
    }
  
    return {
      background: bg,
      color: text
    }
  };

  const getPembayaran = () => {
    if (paymentData.method === 'CASH_ON_DELIVERY') {
      return (
        <Typography sx={{ ...fontSizeTextSmall, color: "darkgray" }}>COD</Typography>
      )
    } else {
      switch (paymentData.channel) {
        case 'QRIS':
          return <img src={logoQris} alt="QRIS Logo" width={45} />
        case 'OVO':
          return <img src={logoOvo} alt="OVO Logo" width={60} style={{ paddingRight: "10px" }} />
        case 'DANA':
          return <img src={logoDana} alt="Dana Logo" width={60} style={{ paddingRight: "10px" }} />
        case 'MANDIRI':
          return <img src={logoMandiri} alt="Mandiri Logo" width={45} style={{ paddingRight: "10px" }}/>
        case 'BRI':
          return <img src={logoBri} alt="BRI Logo" width={45} style={{ paddingRight: "10px" }}/>
        case 'BNI':
          return <img src={logoBni} alt="BNI Logo" width={45} style={{ paddingRight: "10px" }} />
        case 'CIMB':
          return <img src={logoCimb} alt="CIMB Logo" width={45} style={{ paddingRight: "10px" }} />
        case 'PERMATA':
          return <img src={logoPermata} alt="Permata Logo" width={45} style={{ paddingRight: "10px" }} />
        case 'SAHABAT_SAMPOERNA':
          return <img src={logoSampoerna} alt="Sampoerna Logo" width={45} style={{ paddingRight: "10px" }} />
        case 'BJB':
          return <img src={logoBjb} alt="BJB Logo" width={45} style={{ paddingRight: "10px" }} />
        case 'BSI':
          return <img src={logoBsi} alt="BSI Logo" width={45} style={{ paddingRight: "10px" }} />
        default:
          return <img src={noImage} alt="no data" width={45} />
      }
    }
  }

  const fetchOrderData = async () => {
    try {
      const response = await CustomerService.getOrderDetail(id, auth?.user?.phonenumber);
      if (response) {
        const data = response.data;
        setOrderData(data.orderList);
        setPaymentData(data.payment);
        setAddressData(data.address);
        setDeliveryData(data.delivery);

        if (data.orderList.length > 0) {
          const dateString = data.orderList[0].updatedDate.split(" ")[0];
          const [date, month, year] = dateString.split("/");

          setDate(new Date(year, month - 1, date));
          setStatus(data.orderList[0].status);

          let price = 0;
          data.orderList.forEach(order => {
            price += order.price;
          });
          setTotalPrice(price);
        }

        if (data.delivery) {
          trackOrder(data.delivery.awb);
        }
      }
    } catch (error) {
      if (error.response.status === 404) {
        setMsgError("Order tidak ditemukan");
        setShowError(true);
      } else {
        setMsgError("Terjadi kesalahan");
        setShowError(true);
      }
    }
  }

  const trackOrder = async (awb) => {
    try {
      const response = await CustomerService.trackOrder(awb)
      if (response) {
        const data = response.data;
        setTrackData(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (auth?.user) {
      fetchOrderData();
    }
  }, [auth, id])

  return (
    <>
      <Navigation />

      <Container component="main" maxWidth="xl" sx={{ minHeight: "80vh" }}>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={ShowSuccess}
          autoHideDuration={3000}
          onClose={() => setShowSuccess(false)}
        >
          <SnackbarContent
            sx={{ backgroundColor: "#19B600" }} 
            message={MsgSuccess}/>
        </Snackbar>
  
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={showError}
          autoHideDuration={3000}
          onClose={() => setShowError(false)}
        >
          <SnackbarContent 
            sx={{ backgroundColor: "#E50B0B" }} 
            message={msgError}/>
        </Snackbar>

        <Box marginBottom={3} marginTop={3} borderBottom="1px solid black">
          <Typography sx={{ ...fontSizeHeader, textAlign: "center" }}>
            {
              date ? format(date, "dd MMM yyyy") : "Order Detail"
            }
          </Typography>
        </Box>

        <Grid container>
          <Grid item xs={12} md={8} xl={9} sx={{ paddingX: {xs: "unset", md: "20px"} }}>
            {
              status && (
                <Box marginBottom={2}>
                  <Chip
                    sx={{ ...fontSizeText }}
                    label={status?.label} 
                    style={getStatusColor(status?.key)}
                  ></Chip>
                </Box>
              )
            }
            {
              orderData.map(order => (
                <Grid container key={order.id} rowSpacing={0} columnSpacing={3} marginBottom={5} 
                  sx={{ background: grayHex, borderRadius: "16px", padding: "20px" }}>
                  <Grid item xs={12} md={3} position="relative">
                    <img
                      src={
                        order.itemList[0].images?.length <= 0 || order.itemList[0].images == null
                          ? noImage
                          : `${imageUrl}${order.itemList[0].images[0]}`
                      }
                      alt={order.itemList[0].name}
                      style={{
                        width: "100%",
                        aspectRatio: "1 / 1",
                        objectFit: "cover",
                      }}
                    ></img>
                  </Grid>

                  <Grid item xs={12} md={6} 
                    display="flex" flexDirection="column" justifyContent="space-evenly" gap="2px"
                    sx={{ alignItems: {xs: "center", md: "flex-start"} }}
                  >
                    <Box width="fit-content" sx={{ textAlign: {xs: "center", md: "left"} }}>
                      <img 
                        src={order.itemList[0]?.brand?.images == null ? noImage : `${imageUrl}${order.itemList[0].brand.images[0]}`}
                        alt={order.itemList[0]?.brand?.title}
                        style={{ width: "60%", maxWidth: 90, aspectRatio: "3 / 2", objectFit: "contain" }}
                      />
                    </Box>
                    <Typography sx={{ ...textStyle }}>
                      {order.itemList[0].name}
                    </Typography>
                    <Typography sx={{ ...textStyle, fontWeight: "bold" }}>
                      <NumericFormat
                        value={order.price}
                        displayType={"text"}
                        thousandSeparator="."
                        decimalSeparator=","
                        prefix={"Rp. "}
                      />
                    </Typography>
                    <Typography sx={{ ...textStyle }}>
                      Size: {order.itemList[0].variant?.size || '-'}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={3} display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap="10px">
                    
                  </Grid>
                </Grid>
              ))
            }
          </Grid>
          <Grid item xs={12} md={4} xl={3}>
            <Box marginBottom={3}
              sx={{ minHeight: "500px", borderRadius: "19px", background: "white", boxShadow: "5px 5px 5px rgba(0, 0, 0, .2)", 
                padding: "32px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}
            >
              <Grid container>
                <Grid item xs={4}>
                  <Typography sx={{ ...fontSizeTextSmall }}>Pengiriman</Typography>
                </Grid>
                <Grid item xs={8} textAlign="end">
                  {
                    addressData ? (
                      <>
                        <Typography sx={{ ...fontSizeTextSmall, color: "darkgray" }}>{addressData?.detail}</Typography> 
                        <Typography sx={{ ...fontSizeTextSmall, color: "darkgray" }}>{`${addressData?.neighborhood}, ${addressData?.subdistrict}`}</Typography>
                        <Typography sx={{ ...fontSizeTextSmall, color: "darkgray" }}>{`${addressData?.district}, ${addressData?.province}`}</Typography>
                        <Typography sx={{ ...fontSizeTextSmall, color: "darkgray" }}>{addressData?.zipCode}</Typography> 

                        {
                          deliveryData && (
                            <Box onClick={() => setTrackDialog(true)} sx={{ cursor: "pointer" }}>
                              <Typography sx={{ ...fontSizeTextSmall, textDecoration: "underline" }}>Lacak</Typography>
                            </Box>
                          )
                        }
                      </>
                    ) : (
                      <Typography sx={{ ...fontSizeTextSmall }}>-</Typography>
                    )
                  }
                </Grid>
                <Grid item xs={12} marginTop={3}></Grid>
                <Grid item xs={6} display="flex" alignItems="center">
                  <Typography sx={{ ...fontSizeTextSmall }}>Pembayaran</Typography>
                </Grid>
                <Grid item xs={6} textAlign="end">
                  {
                    addressData ? getPembayaran() : (
                      <Typography sx={{ ...fontSizeTextSmall }}>-</Typography>
                    )
                  }
                </Grid>
                <Grid item xs={12} paddingBottom={2} borderBottom="1px solid black"></Grid>
              </Grid>
              <Grid container marginTop={3}>
                <Grid item xs={12} marginBottom={2}>
                  <Typography sx={{ ...fontSizeTextSmall }}>Ringkasan</Typography>
                </Grid>
                
                {
                  paymentData ? (
                    <>
                      <Grid item xs={6}>
                        <Typography sx={{ ...fontSizeTextSmall, color: "darkgray", fontWeight: "bold" }}>Subtotal</Typography>
                      </Grid>
                      <Grid item xs={6} textAlign="end">
                        <Typography sx={{ ...fontSizeTextSmall, color: "darkgray"}}>
                          <NumericFormat
                            value={paymentData.price}
                            displayType={"text"}
                            thousandSeparator="."
                            decimalSeparator=","
                            prefix={"Rp. "}
                          />
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography sx={{ ...fontSizeTextSmall, color: "darkgray", fontWeight: "bold" }}>Pengiriman</Typography>
                      </Grid>
                      <Grid item xs={6} textAlign="end">
                        <Typography sx={{ ...fontSizeTextSmall, color: "darkgray"}}>
                          <NumericFormat
                            value={paymentData.deliveryFee}
                            displayType={"text"}
                            thousandSeparator="."
                            decimalSeparator=","
                            prefix={"Rp. "}
                          />
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography sx={{ ...fontSizeTextSmall, color: "darkgray", fontWeight: "bold" }}>Biaya Admin</Typography>
                      </Grid>
                      <Grid item xs={6} textAlign="end">
                        <Typography sx={{ ...fontSizeTextSmall, color: "darkgray"}}>
                          <NumericFormat
                            value={paymentData.transactionFee}
                            displayType={"text"}
                            thousandSeparator="."
                            decimalSeparator=","
                            prefix={"Rp. "}
                          />
                        </Typography>
                      </Grid>

                      <Grid item xs={6} marginTop={2}>
                        <Typography sx={{ ...fontSizeTextSmall }}>Total</Typography>
                      </Grid>
                      <Grid item xs={6} marginTop={2} textAlign="end">
                        <Typography sx={{ ...fontSizeTextSmall, fontWeight: "bold"}}>
                          <NumericFormat
                            value={paymentData.totalPrice}
                            displayType={"text"}
                            thousandSeparator="."
                            decimalSeparator=","
                            prefix={"Rp. "}
                          />
                        </Typography>
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid item xs={6}>
                        <Typography sx={{ ...fontSizeTextSmall, color: "darkgray", fontWeight: "bold" }}>Subtotal</Typography>
                      </Grid>
                      <Grid item xs={6} textAlign="end">
                        <Typography sx={{ ...fontSizeTextSmall, color: "darkgray"}}>
                          <NumericFormat
                            value={totalPrice}
                            displayType={"text"}
                            thousandSeparator="."
                            decimalSeparator=","
                            prefix={"Rp. "}
                          />
                        </Typography>
                      </Grid>

                      <Grid item xs={6} marginTop={2}>
                        <Typography sx={{ ...fontSizeTextSmall }}>Total</Typography>
                      </Grid>
                      <Grid item xs={6} marginTop={2} textAlign="end">
                        <Typography sx={{ ...fontSizeTextSmall, fontWeight: "bold"}}>
                          <NumericFormat
                            value={totalPrice}
                            displayType={"text"}
                            thousandSeparator="."
                            decimalSeparator=","
                            prefix={"Rp. "}
                          />
                        </Typography>
                      </Grid>
                      {
                        status?.key === 'WAITING_FOR_PAYMENT' && (
                          <Grid item xs={12} marginTop={2} textAlign="end">
                            <Button 
                              sx={{ ...fontSizeTextSmall, background: "transparent", border: "1px solid black", borderRadius: "100px", color: "black", width: "200px", maxWidth: "100%", textTransform: "capitalize" }}
                              onClick={orderData.length > 0 ? () => navigate(`/customer/checkoutPage/${orderData[0]?.id}`) : null}
                            >
                              Check Out
                            </Button>
                          </Grid>
                        )
                      }
                    </>
                  )
                }
              </Grid>
              <Box marginTop={3}>
                <Box marginBottom={1}>
                  <Typography sx={{ ...fontSizeText }}>Butuh Bantuan?</Typography>
                </Box>
                <Box>
                  <Typography sx={{ ...fontSizeTextSmall }}>Shipping and Delivery</Typography>
                </Box>
                <Box>
                  <Typography sx={{ ...fontSizeTextSmall }}>Cancelling an Order</Typography>
                </Box>
                <Box>
                  <Typography sx={{ ...fontSizeTextSmall }}>Returns Policy</Typography>
                </Box>
              </Box>
              <Box marginTop={3}>
                <Box display="flex" alignContent="center">
                  <ChatIcon sx={{ marginRight: "10px" }} />
                  <Typography sx={{ ...fontSizeTextSmall }}>Chat Now</Typography>
                </Box>
                <Box display="flex" alignContent="center">
                  <SmartphoneIcon sx={{ marginRight: "10px" }} />
                  <Typography sx={{ ...fontSizeTextSmall }}>Contact Us</Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>

      <Footer />

      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={trackDialog}
        onClose={() => setTrackDialog(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
      >
        <Fade in={trackDialog}>
          <Box sx={styleModal}>
            <Grid container paddingBottom={1} borderBottom="1px solid black">
              <Grid item xs={6}>
                <Typography sx={{ ...fontSizeTextSmall }}>Kurir</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={{ ...fontSizeTextSmall, color: "darkgray" }}>J&T Express</Typography>
              </Grid>
              {
                deliveryData && (
                  <>
                    <Grid item xs={6}>
                      <Typography sx={{ ...fontSizeTextSmall }}>No Resi</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography sx={{ ...fontSizeTextSmall, color: "darkgray" }}>{deliveryData.awb}</Typography>
                    </Grid>
                  </>
                )
              }
            </Grid>
            <Grid container marginY={1}>
              <Grid item xs={12}>
                <Typography sx={{ ...fontSizeTextSmall }}>Pembaruan Paket</Typography>
              </Grid>
            </Grid>
            <Grid container marginY={1}>
              <Grid item xs={3} md={2}>
                <Typography sx={{ ...fontSizeTextSmall, fontWeight: "bold" }}>Tanggal</Typography>
              </Grid>
              <Grid item xs={3} md={1}>
                <Typography sx={{ ...fontSizeTextSmall, fontWeight: "bold" }}>Waktu</Typography>
              </Grid>
              <Grid item xs={3} md={6}>
                <Typography sx={{ ...fontSizeTextSmall, fontWeight: "bold" }}>Deskripsi</Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography sx={{ ...fontSizeTextSmall, fontWeight: "bold" }}>Lokasi</Typography>
              </Grid>
            </Grid>
            <Grid container marginY={1}>
              {
                deliveryData?.history ? (
                  <>
                    {
                      deliveryData.history.map(history => (
                        <>
                          <Grid container marginY={1}>
                            <Grid item xs={3} md={2}>
                              <Typography sx={{ ...fontSizeTextSmall }}>
                                { format(new Date(history.dateTime), "dd/MM/yyyy") }
                              </Typography>
                            </Grid>
                            <Grid item xs={3} md={1}>
                              <Typography sx={{ ...fontSizeTextSmall }}>
                                { format(new Date(history.dateTime), "HH:mm") }
                              </Typography>
                            </Grid>
                            <Grid item xs={3} md={6}>
                              <Typography sx={{ ...fontSizeTextSmall }}>
                                { history.status }
                              </Typography>
                            </Grid>
                            <Grid item xs={3} md={3}>
                              <Typography sx={{ ...fontSizeTextSmall }}>
                                { history.cityName }
                              </Typography>
                            </Grid>
                          </Grid>
                        </>
                      ))
                    }
                  </>
                ) : (
                  <Grid item xs={12}>
                    <Typography sx={{ ...fontSizeTextSmall, textAlign: "center" }}>Tidak ada data</Typography>
                  </Grid>
                )
              }
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </>
  )
};

export default OrderDetailPage;